export const englishCrmMessages = {
  resources: {
    companies: {
      name: "Company |||| Companies",
      forcedCaseName: "Company",
      fields: {
        name: "Company name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        sector: "Sector",
        size: "Size",
        tax_identifier: "Tax Identifier",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Account manager",
      },
      empty: {
        description: "It seems your company list is empty.",
        title: "No companies found",
      },
      import: {
        title: "Import companies",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
      },
      action: {
        create: "Create Company",
        edit: "Edit company",
        new: "New Company",
        show: "Show company",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      sizes: {
        one_employee: "1 employee",
        two_to_nine_employees: "2-9 employees",
        ten_to_forty_nine_employees: "10-49 employees",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employees",
        two_hundred_fifty_or_more_employees: "250 or more employees",
      },
      autocomplete: {
        create_error: "An error occurred while creating the company",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new company",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Company",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
        created_at: "Created",
        source: "Source",
        source_form: "Form",
        campaign: "Campaign",
        utm: "UTM",
        first_action_at: "First action",
      },
      sources: {
        facebook: "Facebook",
        instagram: "Instagram",
        site: "Website",
        phone: "Phone call",
        referral: "Referral",
        import: "Import",
        manual: "Manual",
        other: "Other",
        instagram_direct: "Instagram Direct",
        messenger: "Messenger",
        walk_in: "Walk-in",
        repeat: "Repeat customer",
      },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        create: "Create contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      autocomplete: {
        create_item: "Create %{item}",
        create_label: "Start typing to create a new contact",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
      },
      import: {
        title: "Import contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
      },
      show: {
        error_loading: "Error loading contact",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected contacts.",
        description:
          "Choose an existing tag or create a new one for the selected contacts.",
        empty: "No tags yet. Create one to tag the selected contacts.",
        error: "Failed to add tag to contacts",
        removed:
          "Tag removed from %{smart_count} contact |||| Tag removed from %{smart_count} contacts",
        success:
          "Tag added to %{smart_count} contact |||| Tag added to %{smart_count} contacts",
        title: "Add tag to contacts",
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        tasks: "Tasks",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        categories: "Categories",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
        apartment_id: "Apartment",
        lost_reason: "Loss reason",
        lost_comment: "Comment",
        lost_at: "Lost on",
      },
      action: {
        back_to_deal: "Back to deal",
        create: "Create deal",
        new: "New Deal",
      },
      field_categories: {
        misc: "Misc",
      },
      filters: {
        only_mine: "Only deals I manage",
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      import: {
        title: "Import deals",
      },
      invalid_date: "Invalid date",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
    },
    sales: {
      name: "User |||| Users",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        secondary_email: "Secondary email",
        secondary_emails: "Secondary emails",
        administrator: "Admin",
        role_id: "Role",
        disabled: "Disabled",
      },
      create: {
        error: "An error occurred while creating the user.",
        success:
          "User created. They will soon receive an email to set their password.",
        title: "Create a new user",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "User updated successfully",
        title: "Edit %{name}",
      },
      action: {
        new: "New user",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        contact_id: "Contact",
        due_short: "due",
      },
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
        create_for: "Create task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your contacts will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
      },
      regarding_contact: "(Re: %{name})",
      updated: "Task updated",
    },
    apartments: {
      name: "Apartment |||| Apartments",
      fields: {
        section: "Section",
        number: "No. on plan",
        floor: "Floor",
        rooms: "Rooms",
        total_area: "Total area",
        living_area: "Living area",
        price_per_m2: "Price per m²",
        status: "Status",
        booked_until: "Booked until",
      },
      statuses: {
        free: "Free",
        booked: "Booked",
        sold: "Sold",
        off: "Not for sale",
      },
    },
    calls: {
      name: "Call |||| Calls",
      fields: {
        started_at: "Date",
        duration_seconds: "Duration",
        result: "Result",
        comment: "Comment",
        recording_url: "Recording",
        contact_id: "Lead",
        sales_id: "Manager",
      },
      results: {
        no_answer: "No answer",
        callback: "Call back",
        viewing_scheduled: "Viewing scheduled",
        not_interested: "Not interested",
        talked: "Talked",
      },
    },
    events: {
      name: "Event |||| Events",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
      empty: "No tags yet.",
    },
  },
  crm: {
    action: {
      reset_password: "Reset Password",
    },
    auth: {
      first_name: "First name",
      last_name: "Last name",
      errors: {
        weak_password: "Password is too short: at least %{min} characters.",
        invalid_credentials: "Wrong email or password.",
        email_not_confirmed:
          "Email is not confirmed yet. Follow the link in the email.",
        user_exists: "A user with this email already exists.",
        rate_limit: "Too many attempts. Wait a minute and try again.",
        link_expired:
          "The link has expired or was already used. Request a new one.",
        same_password: "The new password must differ from the old one.",
        invalid_email: "Check the email address.",
        network: "No connection to the server. Check your internet.",
      },
      login_headline: "Not a single lead gets lost",
      login_subline: "Leads, calls and the apartment chessboard in one place.",
      login_hint: "For sales managers and heads of sales",
      confirmed_sign_in: "I've confirmed, sign in",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      welcome_title: "Welcome to Oselya CRM",
    },
    common: {
      account_manager: "Account manager",
      more_filters: "Filters",
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
    },
    changelog: {
      title: "Changelog",
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      deals_chart: "Upcoming Deal Revenue",
      deals_pipeline: "Deals Pipeline",
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      stepper: {
        install: "Install Oselya CRM",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
    },
    data_import: {
      button: "Import CSV",
      complete:
        "Import complete. Imported %{importCount} records, with %{errorCount} errors",
      csv_file: "CSV File",
      error:
        "Failed to import this file, please make sure you provided a valid CSV file.",
      in_progress: "Import in progress…",
      progress:
        "Imported %{importCount} / %{rowCount} records, with %{errorCount} errors.",
      remaining_time: "Estimated remaining time:",
      resource: "Resource",
      sample_download: "Download CSV sample",
      sample_hint: "Here is a sample CSV file you can use as a template",
      start: "Start import",
      stop: "Stop import",
      stopped:
        "Import stopped. Imported %{importCount} records, with %{errorCount} errors",
      title: "Import data",
    },
    header: {
      import_data: "Import from JSON",
    },
    search: {
      title: "Search",
      placeholder: "Search contacts, companies, deals, tasks and notes...",
      hint: "Type at least %{min} characters to search",
      empty: "No result found",
      error: "Search is unavailable right now. Please try again.",
      untitled_result: "(no title)",
      show_more: "Show more",
      groups: {
        contacts: "Contacts",
        companies: "Companies",
        deals: "Deals",
        tasks: "Tasks",
        contact_notes: "Contact notes",
        deal_notes: "Deal notes",
      },
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, companies, contacts, companies, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import from JSON",
    },
    settings: {
      dashboard: {
        title: "Dashboard",
        old_tag: "Tag of old leads",
        old_tag_hint:
          "Leads with this tag stay out of the headline numbers and red signals, they get a line of their own.",
        old_tag_none: "None",
        default_period: "Default period",
        fast_minutes: "Fast call, min",
        fast_minutes_hint:
          "A call within this many minutes after the request counts as fast.",
        booking_days: "Warn about bookings, days",
        booking_days_hint:
          "Bookings ending within this many days show in «Needs attention».",
        blocks: "What to show",
        showDaily: "Leads per day",
        showAttention: "Needs attention",
        showApartments: "Apartments and money",
        showManagers: "Managers",
      },
      about: "About",
      companies: {
        sectors: "Sectors",
      },
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        lost_reasons: "Loss reasons",
        lost_reasons_help:
          "Asked when a lead moves to Lost. Analytics count them, so keep the list short (8 at most).",
        pipeline_statuses: "Pipeline Statuses",
        stages: "Stages",
      },
      light_mode_logo: "Light Mode Logo",
      notes: {
        statuses: "Statuses",
      },
      connectors: {
        title: "Connectors",
        description:
          "Where leads come from. Access keys stay on the server; here you see status and rules.",
        saved: "Connector settings saved",
        minutes_ago: "%{smart_count} min ago |||| %{smart_count} min ago",
        hours_ago: "%{smart_count} h ago |||| %{smart_count} h ago",
        days_ago: "%{smart_count} day ago |||| %{smart_count} days ago",
        state: {
          on: "Connected",
          off: "Not connected",
          error: "Error",
          soon: "Soon",
        },
        site: {
          name: "Site form",
          hint: "Leads from the project's site straight into the funnel",
        },
        client_ops: {
          name: "Client Ops",
          hint: "Your ads and analytics system: leads, sales and money per ad.",
          about:
            "The CRM sends Client Ops every lead from every source, stage changes, sales and payments; Client Ops sends leads from lead forms. Keys and the secret are shown once and kept only as a hash or in the secret store.",
          endpoints: "API addresses",
          endpoints_hint:
            "Authorization: header Authorization: Bearer <key>. Up to 120 requests a minute per key.",
          keys: "API keys",
          keys_hint:
            "A key for Client Ops. Copy it right away: the CRM will not show it again.",
          key_once: "The key is shown once. Copy it into Client Ops.",
          create_key: "Create key",
          last_used: "last used: %{at}",
          revoked: "revoked",
          revoke: "Revoke",
          revoke_confirm:
            "Revoke the key? Client Ops will no longer connect with it.",
          webhook: "Webhook to Client Ops",
          webhook_hint:
            "Where the CRM sends events: lead.created, lead.status_changed, lead.updated, deal.won, deal.paid, deal.lost, call.analyzed. X-Signature = sha256 HMAC of «X-Timestamp.body».",
          webhook_url: "Client Ops webhook URL",
          enabled: "Send events",
          secret_set: "Signing secret is set (type a new one to replace)",
          secret_none: "No signing secret yet",
          secret_placeholder: "secret from Client Ops, or generate",
          generate_secret: "Generate secret",
          save: "Save",
          secret_once:
            "New signing secret. Shown once, paste it into Client Ops.",
          map: "Stages → normalized statuses",
          map_hint:
            "Your stages stay as they are; Client Ops sees them as new → contacted → qualified → meeting → won → paid.",
          map_fixed:
            "«Won» is always won, with a payment date paid. «Lost» depends on the reason below.",
          reasons: "Lost reasons → lost / junk / no_answer and a reason code",
          log: "Delivery log",
          log_hint:
            "Queued: %{pending}, not sent: %{failed}. Retries after 1 min, 5 min, 30 min, 2 h, 12 h, then «not sent».",
          test_event: "Test event",
          test_queued: "Test event queued, it goes out within a minute",
          col_time: "When",
          col_event: "Event",
          col_status: "State",
          col_code: "Response",
          col_attempts: "Tries",
          status: {
            pending: "queued",
            sending: "sending",
            sent: "sent",
            failed: "not sent",
          },
          retry: "Retry",
          log_empty:
            "No events yet. Switch the webhook on and send a test event.",
          baseline: "Point zero",
          baseline_hint:
            "Starting numbers when the CRM was connected: the base for the «before → after» case. Taken from the last 90 days of CRM data or typed in from the client's words.",
          baseline_at: "Captured %{at} (%{source})",
          baseline_source: {
            data: "from CRM data",
            manual: "typed in",
          },
          baseline_none:
            "Not captured yet. It is captured when the first key is created.",
          b: {
            leads_per_month: "Leads / month",
            conversion_pct: "Lead → sale, %",
            avg_check: "Average check",
            revenue_per_month: "Revenue / month",
            note: "Note: where the numbers come from",
          },
          baseline_capture: "Capture from data",
          baseline_save: "Save typed numbers",
          saved: "Saved",
          copied: "Copied",
        },
        telegram: {
          hint: "Alerts about new leads and overdue tasks, control from the bot",
          not_configured:
            "The bot is not connected yet. The system administrator connects it during deployment.",
          bot: "Bot %{bot}",
          sent_today: "sent today: %{count}",
          linked: "Your Telegram is linked: send /menu to the bot.",
          link: "Link my Telegram",
          link_hint:
            "The bot opens, press «Start». Then the bot knows you are from the CRM.",
          chats: "Chats for alerts",
          no_chats:
            "Add the bot to the sales team group and send /start there (after linking).",
          private: "Private chat",
          waiting: "waiting for approval",
          invite: "Invite link",
          link_error: "Could not create the link: %{error}",
          invite_person: "For a person:",
          invite_group: "For a group (adds the bot):",
          invite_copied: "Link copied, send it to people or a group",
          invite_hint:
            "A person opens the link and presses «Start»: alerts start right away. Valid 7 days, a new link cancels the previous one. For a group use the second link: it adds the bot and switches the group on.",
          buttons:
            "Buttons and owner under lead alerts (when managers work in the CRM)",
          people: "People",
          people_hint:
            "To press the buttons under alerts (Answered, Take it…), a person's Telegram must be linked to their CRM account. Press «Link», send it to the person, they open it and press «Start». Valid 7 days.",
          people_linked: "linked",
          people_link: "Link",
          people_copied: "Link for %{name} copied, send it to that person",
          events: "What to send",
          events_hint:
            "The same switches are in the bot under /menu. Test leads and CSV imports send no alerts.",
          event: {
            new_lead: "🆕 New lead",
            overdue_task: "⏰ Overdue task",
            no_action_24h: "⚠️ Lead without action for 24 h",
            no_leads: "📉 No leads for N hours (threshold in Meta Lead Ads)",
          },
        },
        meta: {
          hint: "Leads from Facebook and Instagram lead forms every minute",
          no_status: "Status unavailable. Check permissions or try later.",
          not_configured:
            "Not connected yet. The system administrator connects it during deployment.",
          checked: "Last check: %{time}",
          never_checked: "Not checked yet",
          counts: "Today: %{today} · this week: %{week}",
          last_lead: "last lead %{time}",
          error: "Meta returned an error: %{error}",
          forms: "Lead forms",
          forms_hint:
            "All forms of the page are picked up automatically. Switch off the ones you do not need and give them a clear name: it shows on the lead card.",
          no_forms: "Forms appear after the first check.",
          archived: "Archived in Meta: %{smart_count} (take no leads)",
          take_leads: "Take leads from this form",
          form_week: "%{smart_count} this week |||| %{smart_count} this week",
          routing: "Who gets new leads",
          routing_round_robin: "In turn",
          routing_none: "Nobody",
          participants_hint:
            "Who is in the queue. Nobody selected: every manager (own leads role). A single person gets everything.",
          routing_none_hint:
            "New leads wait until the owner or head of sales assigns them.",
          alert: "Lead flow check",
          alert_hours: "hours without leads: warn (0 = off)",
          alert_hint: "Telegram will send the warning once it is connected.",
        },
      },
      roles: {
        title: "Roles and access",
        description:
          "What each role is allowed to do. Owner rights cannot be changed.",
        new: "New role",
        name: "Role name",
        action: "Action",
        delete: "Delete role",
        in_use: "A role assigned to someone cannot be deleted",
        permissions: {
          "leads.all": "See all leads",
          "leads.own": "See only own leads",
          "leads.transfer": "Hand leads over between managers",
          "apartments.edit": "Edit apartment prices and statuses",
          dashboard: "Dashboard and analytics",
          import: "Lead import",
          settings: "Settings and funnel stages",
          team: "Team and invitations",
        },
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      sections: {
        branding: "Branding",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use:
          "Cannot remove %{display_name} that are still used by deals: %{items}",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
        },
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    language: "Language",
    funnel: {
      sale: {
        amount: "Sale amount",
        paid: "Paid",
        paid_at: "Payment date",
        cost: "Cost",
        cost_hint: "optional, for the margin",
        margin: "Margin",
        not_paid: "not yet",
        mark_paid: "Paid",
        edit: "Money",
        saved: "Saved",
        done_won: "Sale closed",
        title_won: "Close the sale",
        hint_won:
          "The amount is required: revenue, average check and ad payback come from it.",
        title_paid: "Payment",
        hint_paid: "How much the client paid and when.",
        title_edit: "Money of the deal",
        hint_edit:
          "Amount, payment and cost. A repeat purchase of the same client is a separate deal.",
        submit: "Save",
        submit_won: "Sold",
      },
      title: "Pipeline",
      active: "Active",
      lost: "Lost",
      all_managers: "All managers",
      all_sources: "All sources",
      filters: "Filters",
      filters_reset: "Reset",
      filters_done: "Done",
      tags: {
        all: "All tags",
        add: "Tag",
        none_left: "Every tag is added. Create new ones in Settings → Tags",
        import: "Tag for every row",
        import_none: "No tag",
        import_hint:
          "For example «Old lead» for requests from before the CRM, easy to tell apart and filter.",
      },
      sort: {
        label: "Order",
        newest: "Newest first",
        oldest: "Oldest first",
        stale: "Longest in stage first",
      },
      all_stages: "All stages",
      new_lead: "New lead",
      in_stage: "%{count} d in stage",
      in_stage_today: "less than a day in stage",
      rooms: "%{count}-room",
      apartment: "Apt %{number}",
      empty_stage: "Empty",
      mobile_hint: "Pick a stage above to see its leads.",
      units: {
        minutes: "min",
        hours: "h",
        days: "d",
      },
      status: {
        no_call: "No call for %{count} %{unit}",
        overdue: "Overdue by %{count} %{unit}",
        today: "%{task} today at %{time}",
        tomorrow: "%{task} tomorrow at %{time}",
        later: "%{task} %{date}",
        booked_until: "Booked until %{date}",
      },
      lost_list: {
        client: "Client",
        reason: "Reason",
        lost_at_stage: "Lost at stage",
        manager: "Manager",
        when: "When",
        restore: "Back to work",
        restored: "Lead moved back to New",
        all: "All",
        hint: "A lost lead can be brought back to work, it goes to the New stage.",
        top_reason: 'Most frequent reason: "%{reason}", %{count} of %{total}.',
        empty: "No lost leads",
      },
      lost_dialog: {
        title: "Why was the lead lost?",
        description: "The reason is required: analytics count it.",
        comment: 'Comment (required for "Other")',
        comment_placeholder: "Briefly, what happened",
        submit: "Mark lead lost",
        done: "Lead moved to lost",
      },
      lead: {
        comments: "Comments",
        no_comments: "No comments yet.",
        form_answers: "Form answers",
        system: "System",
        note_placeholder: "What matters about this client",
        add_comment: "Add comment",
        back: "Pipeline",
        call: "Call",
        new_task: "New task",
        transfer: "Hand over",
        lose: "Lead lost",
        call_result: "Call result",
        comment: "Comment",
        comment_placeholder: "What was agreed, what the client wants",
        next_action: "Next action",
        next_action_placeholder: "For example, apartment viewing",
        when: "When",
        saved: "Call saved",
        choose_result: "Choose the call result",
        history: "History",
        no_history: "No events yet",
        contact: "Contact",
        phone: "Phone",
        source: "Source",
        form: 'form "%{form}"',
        created: "Created",
        manager: "Manager",
        apartment: "Apartment",
        change: "Change",
        no_apartment: "No apartment chosen",
        no_apartment_choice: "No apartment",
        section_number: "Section %{section} · apt %{number}",
        apartment_line: "floor %{floor} · %{rooms} rooms",
        tasks: "Tasks",
        no_tasks: "No open tasks",
        task_text: "What to do",
        add_task: "Add task",
        task_added: "Task added",
        transferred: "Lead handed over",
        stage_changed: "Stage changed",
        not_found: "Lead not found",
        no_call_badge: "No call",
      },
      new: {
        title: "New lead",
        phone: "Phone",
        name: "Name",
        name_placeholder: "How to address them",
        source: "Source",
        source_pick: "Where is the client from? (required)",
        called_number: "Which number they called (if several)",
        rooms: "Interested in",
        rooms_option: "%{count}-room",
        comment: "Comment",
        comment_placeholder: "What the client said",
        manager: "Manager",
        submit: "Create lead",
        attention: "Note",
        duplicate: 'This number already exists: %{name}, stage "%{stage}".',
        open: "Open",
        created: "Lead created",
        no_name: "No name",
      },
      events: {
        lead_created: "Lead created",
        lead_created_from: "Lead created, source: %{source}",
        lead_assigned: "Lead handed to another manager",
        deal_created: "Deal created",
        deal_stage_changed: "Stage: %{from} → %{to}",
        deal_lost: "Lead lost: %{reason}",
        deal_assigned: "Deal handed to another manager",
        deal_apartment_changed: "Apartment changed",
        call_logged: "Call: %{result}",
        task_created: "Task: %{task}",
        task_done: "Task done",
        other: "Event",
      },
    },
    today: {
      title: "Today",
      all: "All",
      new: "New",
      overdue: "Overdue",
      call_now: "Call now",
      tasks_today: "Tasks for today",
      nothing: "All done for today",
      call: "Call %{name}",
      yesterday: "Yesterday",
      overdue_badge: "Overdue",
      new_badge: "New",
    },
    buyer: {
      title: "Buyer profile",
      temperature_label: "Temperature",
      rooms_label: "Rooms",
      consent_given: "Consent given",
      budget: "Budget",
      family: "Family",
      decision_maker: "Who decides",
      consent: "Mailing consent",
      consent_since: "consent since %{date}",
      consent_hint: "Without consent the client stays out of mailings",
      placeholder: {
        budget_min: "from",
        budget_max: "to",
        family: "e.g. couple, two kids",
        decision_maker: "e.g. wife, parents",
        contact_time: "best time",
        residence_country: "country",
      },
      temperature: { cold: "❄ Cold", warm: "🌤 Warm", hot: "🔥 Hot" },
      payment_method: {
        label: "Payment",
        cash: "Cash",
        installments: "Installments",
        mortgage: "Mortgage",
        eoselia: "eOselia",
        certificate: "Certificate",
        other: "Other",
      },
      purpose: {
        label: "Purpose",
        live: "To live",
        invest: "Investment",
        family: "For family",
        rent: "To rent out",
      },
      buy_timing: {
        label: "Buys when",
        now: "Now",
        months: "1–3 months",
        half_year: "Half a year",
        thinking: "Thinking",
      },
      wishes: {
        label: "Matters",
        floor_low: "Low floor",
        floor_high: "High floor",
        balcony: "Balcony",
        view: "View",
        parking: "Parking",
        storage: "Storage",
      },
      residence: {
        label: "Lives in",
        local: "Tiachiv",
        region: "Zakarpattia",
        ukraine: "Other region",
        abroad: "Abroad",
      },
      language: {
        label: "Language",
        uk: "Ukrainian",
        hu: "Hungarian",
        ro: "Romanian",
        other: "Other",
      },
      contact_channel: {
        label: "Contact",
        call: "Call",
        viber: "Viber",
        telegram: "Telegram",
        whatsapp: "WhatsApp",
      },
      objections: {
        label: "Objections",
        expensive: "Expensive",
        far: "Far",
        waiting_build: "Waits for completion",
        distrust: "Distrust",
        comparing: "Compares with another project",
        other: "Other",
      },
    },
    scripts: {
      title: "Scripts",
      on_call: "Call script",
      if_client_says: "If the client says",
      all: "All scripts",
      any_stage: "Any stage",
      new: "New script",
      new_title: "New script",
      step_title: "Greeting",
      name: "Name",
      stage: "For stage",
      active: "On",
      steps: "Call steps",
      name_hint:
        "Write {name}: the lead card puts the client's first name there.",
      add_step: "Add step",
      objections: "Answers to objections",
      custom_objection: "Own objection",
      steps_count: "%{smart_count} step |||| %{smart_count} steps",
      empty: "No scripts yet.",
      saved: "Script saved",
      confirm_delete: "Delete this script?",
      ai_title: "AI call analysis",
      ai_hint:
        "Once telephony with recordings is connected, every call is transcribed and checked against this script: a score, where the manager left the script, which objections came up, the next step.",
    },
    tasks_page: {
      title: "Tasks",
      tab_today: "Today",
      tab_overdue: "Overdue",
      tab_all: "All",
      overdue: "Overdue",
      today: "Today",
      later: "Later",
      no_date: "No due date",
      empty: "Everything waiting for you is closed.",
      done: "Task done",
      empty_title: "All done!",
      action_done: "Done",
      minutes: "min",
      hour: "h",
      tomorrow: "Tomorrow",
      open: "Open",
      focus: "In focus now",
      in: "in %{time}",
      late: "%{time} late",
      min_short: "%{count} min",
      hour_short: "%{count} h",
      progress: "Done today: %{done} of %{total}",
      left_today: "%{smart_count} task left |||| %{smart_count} tasks left",
      all_done: "That is all for today. Nice 👏",
      free_day: "No tasks for today",
      sound_on: "Sound",
      sound_off: "Muted",
      nudge: {
        soon: "⏰ In a few minutes",
        now: "🔔 Now",
        overdue: "⚠️ Overdue",
      },
    },
    team: {
      title: "Team",
      subtitle: "%{count} in the team",
      unassigned: "%{count} leads without an owner",
      you: "(you)",
      open: "Open",
      invite: "Invite someone",
      own_role:
        "You cannot change your own role, it could lock you out. Ask another owner or the developer.",
      invite_hint:
        "They get an email with a password. The first manager starts getting Meta leads at once.",
      tg_on: "Telegram linked",
      tg_off: "Telegram not linked",
      about: {
        owner: "Sees everything: money, leads, the team and the apartments.",
        developer: "Builds and runs the system: integrations, log, settings.",
        admin:
          "The system's concierge: people, access, Telegram. No buyer data.",
        rop: "Runs the team: hands out leads, watches calls and viewings.",
        manager: "Calls, shows apartments, gets to a booking.",
      },
      s: {
        sold_month: "sold this month",
        leads_month: "leads this month",
        free_flats: "free apartments",
        errors: "errors in 24 h",
        jobs: "background jobs",
        queue: "in Telegram queue",
        people: "in the team",
        telegram: "in Telegram",
        roles: "roles",
        team_active: "in progress in the team",
        team_no_call: "waiting for a call",
        team_won: "sales this month",
      },
      stats: {
        active: "in progress",
        no_call: "no call",
        won: "sales this month",
      },
    },
    import_leads: {
      title: "Lead import",
      subtitle: "Upload a CSV file, for example a Meta Lead Ads export.",
      step_file: "File",
      step_columns: "Columns",
      step_check: "Check",
      choose: "Drop the file here",
      drop: "or pick it on your computer",
      pick: "Choose file",
      meta_title: "How to export leads from Meta",
      meta_step_1:
        "Meta Business Suite → All tools → Leads Center (or Instant forms).",
      meta_step_2: "Pick the form and period, press «Download» → CSV.",
      meta_step_3: "Drop the file here: the columns map themselves.",
      what_title: "What happens",
      what_dupes:
        "Phones already in the CRM and repeats in the file are skipped.",
      what_stage: "Every lead becomes a deal at the «New» stage.",
      what_date: "The request date comes from the file, not today.",
      what_quiet: "Nothing is sent to Telegram for the import.",
      what_tag: "You can tag every row, e.g. «Old lead».",
      formats:
        "CSV or TSV with comma, semicolon or tab. A Meta export opens as is.",
      empty:
        "The file is empty. If you drag it from an archive window (7-Zip, WinRAR), extract the files to a folder first and drag from there.",
      zip: "This is an archive. Extract it and drop the .csv file here.",
      unreadable:
        "Could not read the file. Check it is a CSV with a header row.",
      mapping_title: "Map each column",
      file: "File",
      rows: "%{smart_count} row |||| %{smart_count} rows",
      default_source: "Source when the file has none",
      manager: "Manager",
      no_manager: "No manager (assign later)",
      hint: "Before importing, the system checks duplicate phones and rows without a number. Imported leads go to the New stage.",
      need_phone: "Map the phone column: a lead needs a phone.",
      next: "Next",
      will_import: "will be imported",
      no_phone: "without phone",
      dup_base: "already in the base",
      dup_file: "repeated in the file",
      and_more: "and %{count} more",
      run: "Import %{smart_count} lead |||| Import %{smart_count} leads",
      progress: "Imported %{done} of %{total}",
      failed: "errors: %{count}",
      to_funnel: "Go to the pipeline",
      targets: {
        full_name: "Full name",
        first_name: "First name",
        last_name: "Last name",
        phone: "Phone",
        email: "Email",
        created_at: "Created on",
        campaign: "Campaign",
        form: "Form",
        source: "Source",
        rooms: "Rooms",
        utm_source: "utm_source",
        utm_medium: "utm_medium",
        utm_campaign: "utm_campaign",
        utm_content: "utm_content",
        utm_term: "utm_term",
        comment: "Into the comment",
        ignore: "Do not import",
      },
    },
    apartments: {
      empty:
        "No apartments yet. Load the apartment register (sections, floors, areas).",
      section: "Section %{section}",
      all: "All",
      area: "Area",
      area_filters: {
        any: "Any",
        under40: "under 40 m²",
        "40to60": "40–60 m²",
        over60: "60 m² and more",
      },
      counts: {
        free: "Free",
        booked: "Booked",
        sold: "Sold",
        off: "Not for sale",
      },
      rooms_short: "%{count}r",
      only_free: "Only free",
      section_short: "Section %{section}",
      pick_title: "Choose an apartment",
      pick_hint:
        "Green ones are free and can be chosen. The rooms the client asked for are shown first.",
      free_of: "%{free} of %{total} free",
      stripe_hint: "The left stripe shows the number of rooms",
      floor: "floor",
      until: "until %{date}",
      pick: "Pick an apartment on the chessboard.",
      total: "Total",
      living: "Living",
      held_for: "Deal:",
      price: "Price per m², $",
      no_price: "Not set yet",
      total_price: "Total: %{total} $",
      saved: "Apartment saved",
      rights_hint:
        'Prices and statuses are changed by people with the "Edit apartment prices and statuses" right. Others see the chessboard read-only.',
    },
    view_as: {
      label: "View as role",
      banner:
        "You see the CRM as «%{role}»: the same data and rights as this role.",
      back: "Back to developer",
    },
    system: {
      title: "System log",
      refresh: "Refresh",
      report: "Download report (zip)",
      report_building: "Building the report…",
      system_actor: "System",
      errors_sub: "errors in 24 h",
      leads_today: "leads today: %{count}",
      telegram_sub: "queued: %{count}",
      users_sub: "active users",
      jobs: "Background jobs",
      no_errors: "No errors.",
      open: "Open",
      cards: {
        errors: "Errors",
        last_lead: "Last lead",
        telegram: "Telegram in 24 h",
        users: "Users",
      },
      tabs: {
        errors: "System errors",
        actions: "Actions in the CRM",
      },
      levels: {
        all: "All",
        error: "Errors",
        warn: "Warnings",
      },
      col: {
        time: "Time",
        who: "Who",
        what: "What",
      },
      events: {
        lead_created: "New lead",
        deal_created: "Deal created",
        deal_stage_changed: "Stage: %{from} → %{to}",
        deal_lost: "Deal lost (%{reason})",
        call_logged: "Call: %{result}",
        task_created: "New task",
        task_done: "Task done",
        apartment_status_changed: "Apartment: %{from} → %{to}",
      },
    },
    owner_overview: {
      kpi: {
        leads: "New leads",
        fast: "Called within %{minutes} min",
        viewings: "Viewings",
        sales: "Sales",
      },
      fast_sub: "%{fast} of %{leads} leads",
      vs_prev: "previous period: %{value}",
      all_time: "all time",
      daily: "Leads per day · %{days} d.",
      daily_total: "%{count} in total",
      sources: {
        facebook: "Facebook",
        instagram: "Instagram",
        other: "Website and other",
      },
      attention: "Needs attention",
      att: {
        new_no_call: "New leads without a call",
        overdue_tasks: "Overdue tasks",
        bookings_ending: "Bookings ending within %{days} days",
        unassigned: "Leads without an owner",
        old_no_call: "Old leads without a call",
      },
      all_good:
        "All under control: no leads waiting for a call, no overdue tasks.",
      apartments: "Apartments and money",
      sold_of: "Sold for %{sold} of %{total}",
      managers: "Managers",
      no_managers: "No managers yet.",
      m: {
        name: "Manager",
        leads: "leads",
        fast: "call ≤%{minutes} min",
        viewings: "viewings",
        sales: "sales",
        waiting: "waiting for a call",
        no_call: "%{count} waiting for a call",
      },
      details: "Funnel and sources",
    },
    owner_dashboard: {
      periods: {
        week: "Week",
        month: "Month",
        all: "All time",
      },
      reaction: "First response time",
      reaction_hint: "median: from lead arrival to first action",
      call_5: "Called within 5 min",
      call_15: "within 15 min: %{value}",
      no_action: "No action for 24 h+",
      no_action_hint: "leads with no call and no task",
      overdue: "Overdue tasks",
      overdue_hint: "open tasks past their due date",
      funnel: "Where the funnel leaks",
      funnel_hint:
        "The percent shows how many leads made it from the previous stage.",
      warm: "Warmest leads",
      no_warm: "No warm leads yet",
      warm_hint: "Counted by simple rules, shown on each row.",
      rules: {
        answered: "answered a call",
        viewed: "came to a viewing",
        repeat: "repeat contact",
      },
      sources: "Sources → viewing → sale",
      source: "Source",
      source_leads: "Leads",
      source_viewings: "Reached viewing",
      source_won: "Sold",
      more: "More",
    },
    navigation: {
      label: "CRM navigation",
      pipeline: "Pipeline",
      tasks: "Tasks",
      today: "Today",
      import_leads: "Lead import",
      apartments: "Apartments",
      team: "Team",
    },
    profile: {
      add_secondary_email: "Add an email",
      email_taken: "%{email} is already used by another user",
      no_secondary_emails: "None",
      secondary_email_invalid: "%{email} is not a valid email address",
      secondary_email_is_primary: "%{email} is already your main address",
      secondary_email_taken: "%{email} is already used by another user",
      too_many_secondary_emails:
        "You cannot add more than 10 secondary email addresses",
      secondary_emails_help:
        "Other addresses you send emails from. Leave one empty to remove it.",
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. The CRM will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
      },
      password: {
        change: "Change password",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
